import { render } from "./FileEditPage.vue?vue&type=template&id=545e8636"
import script from "./FileEditPage.vue?vue&type=script&lang=js"
export * from "./FileEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__